import { Script } from "gatsby";
import { useEffect, useState, type FC } from "react";
import { useAppState } from "../../context/app/context";

const ZendeskWidget: FC = () => {
	const [zendeskExists, setZendeskExists] = useState(false);
	const [zendeskLoaded, setZendeskLoaded] = useState(false);

	const { siteConfig, userCountry } = useAppState();

	useEffect(() => {
		if (!window.zE) return;

		// eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
		if (zendeskExists && !zendeskLoaded) {
			window.zE("messenger", "close");
			window.zE("messenger:set", "zIndex", 10);
			setZendeskLoaded(true);
		}

		if (zendeskExists && userCountry)
			window.zE("messenger:set", "locale", userCountry);
	}, [zendeskExists, zendeskLoaded, userCountry]);

	useEffect(() => {
		// eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
		if (!zendeskExists) {
			const id = setTimeout(() => {
				if (window.zE) {
					setZendeskExists(true);
				}
			}, 500);
			return () => clearTimeout(id);
		}
	}, [zendeskExists]);

	return siteConfig.zendesk_key && userCountry ? (
		<Script
			id="ze-snippet"
			src={`https://static.zdassets.com/ekr/snippet.js?key=${siteConfig.zendesk_key}`}
			strategy="idle"
		/>
	) : null;
};

export default ZendeskWidget;
